module["exports"] = [
  "#{city_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/city.js
 ** module id = 905
 ** module chunks = 0
 **/